import { GirafeHTMLElement } from '@geogirafe/lib-geoportal/base';
import { IGirafePanel } from '@geogirafe/lib-geoportal/core';

type ApplicationItem = {
  name: string;
  title: string;
  description: string;
  url: string;
};

export default class ApplicationsComponent extends GirafeHTMLElement implements IGirafePanel {
  templateUrl = './template.html';
  styleUrls = ['../../../node_modules/@geogirafe/lib-geoportal/styles/common.css', './style.css'];

  isPanelVisible = false;
  panelTitle = 'Weitere Anwendungen';
  panelTogglePath = 'extendedState.applications.visible';

  constructor() {
    super('applications-component');
  }

  protected get Config() {
    return this.context.configManager.Config.extendedConfig!.applications;
  }

  // registerEvents() {
  //   this.subscribe('extendedState.applications.visible', () => this.togglePanel());
  // }

  public togglePanel(visible: boolean) {
    if (this.isPanelVisible == visible) return;
    this.isPanelVisible = visible;
    this.render();
  }

  override connectedCallback() {
    super.connectedCallback();
    this.state.extendedState.applications = {
      visible: false,
      items: []
    };
    this.render();
    // this.registerEvents();
  }

  public openLink(item: ApplicationItem) {
    let url = item.url.replace('{x}', this.state.position?.center[0].toString());
    url = url.replace('{y}', this.state.position?.center[1].toString());
    url = url.replace('{z}', this.state.position?.zoom!.toString());
    window.open(url, '_blank');
  }

  override render(): void {
    if (this.isPanelVisible) {
      super.render();
    } else {
      this.hide();
    }
  }
}
